import styles from './Whyi3.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface ReasonItem {
  icon: string
  title: string
  text: string | string[]
}

interface Props {
  list: ReasonItem[]
}

const Whyi3: React.FC<Props> = ({ list }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.reason} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>選ばれる理由</h2>
      <div className={styles.reasonList}>
        {list.map((item, index) => (
          <section key={index} className={styles.reasonItem}>
            <div className={styles.reasonItem__title}>
              <img src={item.icon} alt={item.title} width={40} height={40} className={styles.reasonItem__title__img} />
              <h3 className={styles.reasonItem__title__text}>{item.title}</h3>
            </div>
            <div className={styles.reasonItem__text}>
              {Array.isArray(item.text) ? (
                item.text.map((paragraph, i) => (
                  <p key={i} className={styles.reasonItem__text__each}>
                    {paragraph}
                  </p>
                ))
              ) : (
                <p className={styles.reasonItem__text__each}>{item.text}</p>
              )}
            </div>
          </section>
        ))}
      </div>
    </section>
  )
}

export default Whyi3
